var path = 'directives/qrScanner.html';
var html = "<video data-ng-if=!state.read autoplay></video>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/qrScanner.html
// module id = uazT
// module chunks = 1 2